import React from "react";

export default ({ value, children }) => (
  <option value={value}>{children}</option>
);
